export const hasMinTenChars = (str: string): boolean => {
	if (str?.length > 9) {
		return true;
	}

	return false;
};

export const hasAtleastOneUpperCase = (str: string): boolean => {
	const regex = /[A-Z]/g;
	const found = str.match(regex) || [];

	if (found?.length) {
		return true;
	}

	return false;
};

export const hasAtleastOneLowerCase = (str: string): boolean => {
	const regex = /[a-z]/g;
	const found = str.match(regex) || [];

	if (found?.length) {
		return true;
	}

	return false;
};

export const hasAtleastOneSpecialChar = (str: string): boolean => {
	// eslint-disable-next-line
	const regex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g;
	const found = str.match(regex) || [];

	if (found?.length) {
		return true;
	}

	return false;
};
